import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './iconContent.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

let containerClass = "container flex px-3 mx-auto flex flex-wrap flex-col md:flex-row "+styles.contentTable;

function IconContent(props) {
    const img = maybeImage(props.illustration);
    let bgcolor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';
    return (
        <div className={styles.sectionIconContent} style={{ backgroundColor: `${bgcolor}`}}>
            <div className={containerClass}>
                <div className={styles.imgCol}>{img}</div>
                <div className={styles.contentCol}>
                    <h3>{props.heading}</h3>
                    <div className={styles.contentWrap}>
                        <PortableText blocks={props.content} />
                    </div>
                </div>
            </div>
        </div>
    );
}
  
export default IconContent;